import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "py-4 sm:py-8 sm:p-8" }
const _hoisted_2 = { class: "mb-10 flex items-center justify-between" }
const _hoisted_3 = { class: "flex items-center gap-2" }
const _hoisted_4 = { class: "text-sm font-medium text-white" }
const _hoisted_5 = { class: "text-sm font-medium text-white" }
const _hoisted_6 = { class: "text-sm text-white" }
const _hoisted_7 = { class: "text-sm text-white" }
const _hoisted_8 = { class: "text-sm text-white" }
const _hoisted_9 = { class: "text-sm text-white" }
const _hoisted_10 = { class: "group flex items-center gap-2" }
const _hoisted_11 = { class: "max-w-md truncate text-sm text-blue-300 hover:text-blue-200 transition-colors" }
const _hoisted_12 = {
  key: 1,
  class: "text-xs text-green-400 animate-fade-in-out"
}
const _hoisted_13 = { class: "flex justify-end gap-2" }
const _hoisted_14 = {
  key: 0,
  class: "space-y-4 md:hidden text-left"
}
const _hoisted_15 = { class: "flex items-center gap-2" }
const _hoisted_16 = { class: "flex flex-col" }
const _hoisted_17 = { class: "flex items-center gap-2" }
const _hoisted_18 = { class: "text-white font-bold text-lg" }
const _hoisted_19 = { class: "flex flex-col items-end gap-2" }
const _hoisted_20 = { class: "flex items-center gap-1" }
const _hoisted_21 = ["onClick"]
const _hoisted_22 = ["onClick"]
const _hoisted_23 = { class: "grid grid-cols-2 gap-4" }
const _hoisted_24 = { class: "flex items-center gap-2 bg-white/5 p-2 rounded justify-between" }
const _hoisted_25 = { class: "font-mono text-xs text-blue-300 truncate max-w-[250px]" }
const _hoisted_26 = ["onClick"]
const _hoisted_27 = {
  key: 1,
  class: "text-center py-12 text-zinc-500"
}
const _hoisted_28 = { class: "grid gap-6 py-4" }
const _hoisted_29 = { class: "grid gap-2" }
const _hoisted_30 = { class: "grid gap-2" }
const _hoisted_31 = { class: "grid gap-2" }
const _hoisted_32 = { class: "grid gap-2" }
const _hoisted_33 = { class: "grid gap-2" }
const _hoisted_34 = { class: "grid gap-2" }

import { ref, onMounted, watch, computed } from 'vue'
import {
  ArrowsUpDownIcon,
  LinkIcon,
  ClipboardIcon,
  PencilIcon,
  TrashIcon,
} from '@heroicons/vue/24/outline'
import MobileCard from '@/components/ui/mobile-card/MobileCard.vue'
import MobileDataLabel from '@/components/ui/mobile-card/MobileDataLabel.vue'
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog'
import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import RegisterButton from '@/components/ui/register-button/RegisterButton.vue'
import Table from '@/components/ui/table/Table.vue'
import TableHeader from '@/components/ui/table/TableHeader.vue'
import TableBody from '@/components/ui/table/TableBody.vue'
import TableRow from '@/components/ui/table/TableRow.vue'
import TableHead from '@/components/ui/table/TableHead.vue'
import TableFallback from '@/components/ui/table/TableFallback.vue'
import TableCell from '@/components/ui/table/TableCell.vue'
import Pagination from '@/components/ui/pagination/Pagination.vue'
import TableContainer from '@/components/ui/table/TableContainer.vue'
import { GetAllUtmLinksParams, useUtmLink } from '@/composables/useUtmLink'
import { Pagination as IPagination } from '@/interfaces/Pagination'
import { UtmLink } from '@/interfaces/UtmLink'
import TableRowSkeleton from '@/components/ui/table/TableRowSkeleton.vue'
import { useToast } from '@/components/ui/toast'
import { CheckIcon, Loader2 } from 'lucide-vue-next'
import DeleteConfirmationDialog from '@/components/ui/delete-dialog/DeleteConfirmationDialog.vue'
import PageTitle from '@/components/ui/page/PageTitle.vue'
import PageDescription from '@/components/ui/page/PageDescription.vue'
import { useBot } from '../../composables/useBot'

// Table Configuration

export default /*@__PURE__*/_defineComponent({
  __name: 'ManageUtmLinks',
  setup(__props) {

const tableHeaders = [
  { key: 'name', label: 'Nome', sortable: false },
  { key: 'campaignName', label: 'Campanha', sortable: false },
  { key: 'source', label: 'Origem', sortable: false },
  { key: 'medium', label: 'Meio', sortable: false },
  { key: 'content', label: 'Conteúdo', sortable: false },
  { key: 'startParam', label: 'Palavra-Chave', sortable: false },
  { key: 'link', label: 'Link', sortable: false },
  { key: 'actions', label: '', class: 'w-32' },
]

// Data
const utmLinks = ref<IPagination<UtmLink>>()
const { getAll, create, update, destroy } = useUtmLink()
const { botLink } = useBot()
const { toast } = useToast()

// Dialog and Form
const isSaving = ref(false)
const isLinkDialogOpen = ref(false)
const editingLinkId = ref<number | null>(null)
const deletingLinkId = ref<number | null>(null)
const isDeleteLinkDialogOpen = ref(false)
const isDeletingLink = ref(false)
const utmLinkForm = ref({
  name: '',
  campaignName: '',
  source: '',
  medium: '',
  content: '',
  leadStartParameterContent: ''
})
const perPage = ref('10')

// Computed
const isFormValid = computed(() => {
  return utmLinkForm.value.campaignName && 
          utmLinkForm.value.source && 
          utmLinkForm.value.medium && 
          utmLinkForm.value.content && 
          utmLinkForm.value.leadStartParameterContent
})

// Utils
// const copyLink = async (url: string) => {
//   await navigator.clipboard.writeText(url)
//   toast({
//     title: 'Link copiado!',
//     class: 'bg-green-500 text-white',
//     duration: 1500
//   })
// }

// Actions
const openNewLinkDialog = () => {
  editingLinkId.value = null
  utmLinkForm.value = {
    name: '',
    campaignName: '',
    source: '',
    medium: '',
    content: '',
    leadStartParameterContent: ''
  }
  isLinkDialogOpen.value = true
}

const closeLinkDialog = () => {
  isLinkDialogOpen.value = false
}

const editUtmLink = (link: UtmLink) => {
  editingLinkId.value = link.id
  utmLinkForm.value = {
    name: link.name,
    campaignName: link.campaignName,
    source: link.source,
    medium: link.medium,
    content: link.content,
    leadStartParameterContent: link.leadStartParameter!.content
  }
  isLinkDialogOpen.value = true
}

const saveUtmLink = () => {
  isSaving.value = true

  if (!editingLinkId.value) {
    create(utmLinkForm.value).then((newLink) => {
      isSaving.value = false
      toast({
        title: 'Link UTM criado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      getAll().then((data) => utmLinks.value = data)
      closeLinkDialog()
    }).catch(() => {
      isSaving.value = false
    })
  } else {
    update(editingLinkId.value, utmLinkForm.value).then(() => {
      isSaving.value = false
      toast({
        title: 'Link UTM editado com sucesso',
        class: 'bg-green-500 text-white',
        duration: 1500
      })
      const index = utmLinks.value?.data.findIndex(link => link.id == editingLinkId.value)
      if (index !== -1 && index !== null && index !== undefined) {
        utmLinks.value!.data[index] = {
          ...utmLinks.value!.data[index],
          ...utmLinkForm.value
        }
      }
      closeLinkDialog()
    }).catch(() => {
      isSaving.value = false
    })
  }
}

const deleteLink = (link: UtmLink) => {
  isDeleteLinkDialogOpen.value = true
  deletingLinkId.value = link.id
}

const sortBy = (key: string) => {
  // Implement sorting logic if needed
}

const reloadAndGetAll = (params: GetAllUtmLinksParams) => {
  utmLinks.value = undefined
  getAll(params).then((data) => utmLinks.value = data)
}

const copiedLink = ref<string | null>(null)

// Atualize a função copyLink
const copyLink = async (url: string) => {
  await navigator.clipboard.writeText(url)
  copiedLink.value = url
  setTimeout(() => {
    copiedLink.value = null
  }, 2000)
  
  toast({
    title: 'Link copiado!',
    class: 'bg-green-500 text-white',
    duration: 1500
  })
}

watch(() => perPage.value, () => {
  reloadAndGetAll({ perPage: perPage.value })
})

onMounted(() => {
  getAll().then((data) => utmLinks.value = data)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("main", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", null, [
          _createVNode(PageTitle, null, {
            default: _withCtx(() => _cache[11] || (_cache[11] = [
              _createTextVNode(" Gerencie seus links UTM ")
            ])),
            _: 1
          }),
          _createVNode(PageDescription, null, {
            default: _withCtx(() => _cache[12] || (_cache[12] = [
              _createTextVNode(" Rastreie suas vendas de forma precisa com links UTM. ")
            ])),
            _: 1
          })
        ]),
        _createVNode(RegisterButton, { onClick: openNewLinkDialog }, {
          default: _withCtx(() => _cache[13] || (_cache[13] = [
            _createTextVNode("Cadastrar link UTM")
          ])),
          _: 1
        })
      ]),
      _createVNode(TableContainer, null, {
        default: _withCtx(() => [
          _cache[17] || (_cache[17] = _createElementVNode("div", { class: "mb-6 flex items-center justify-between" }, [
            _createElementVNode("h2", { class: "text-xl font-semibold text-white" }, "Links UTM registrados"),
            _createElementVNode("div", { class: "flex items-center gap-4" })
          ], -1)),
          _createVNode(Table, { class: "hidden md:block" }, {
            default: _withCtx(() => [
              _createVNode(TableHeader, null, {
                default: _withCtx(() => [
                  _createVNode(TableRow, null, {
                    default: _withCtx(() => [
                      (_openBlock(), _createElementBlock(_Fragment, null, _renderList(tableHeaders, (header) => {
                        return _createVNode(TableHead, {
                          key: header.key,
                          class: _normalizeClass(header.class)
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_3, [
                              _createTextVNode(_toDisplayString(header.label) + " ", 1),
                              (header.sortable)
                                ? (_openBlock(), _createBlock(_unref(ArrowsUpDownIcon), {
                                    key: 0,
                                    class: "h-4 w-4 cursor-pointer text-gray-500 hover:text-white",
                                    onClick: ($event: any) => (sortBy(header.key))
                                  }, null, 8, ["onClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["class"])
                      }), 64))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(TableBody, null, {
                default: _withCtx(() => [
                  (utmLinks.value)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        (utmLinks.value.data.length === 0)
                          ? (_openBlock(), _createBlock(TableFallback, {
                              key: 0,
                              colspan: tableHeaders.length,
                              icon: _unref(LinkIcon),
                              title: "Nenhum link UTM encontrado",
                              description: `Clique em 'Cadastrar link UTM' para começar`
                            }, null, 8, ["colspan", "icon"]))
                          : _createCommentVNode("", true),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(utmLinks.value.data, (utmLink) => {
                          return (_openBlock(), _createBlock(TableRow, {
                            key: utmLink.id
                          }, {
                            default: _withCtx(() => [
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_4, _toDisplayString(utmLink.name), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_5, _toDisplayString(utmLink.campaignName), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(utmLink.source), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_7, _toDisplayString(utmLink.medium), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_8, _toDisplayString(utmLink.content), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, _toDisplayString(utmLink.leadStartParameter?.content), 1)
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, _toDisplayString(_unref(botLink)) + _toDisplayString(utmLink.leadStartParameter?.content), 1),
                                    (copiedLink.value !== `${_unref(botLink)}${utmLink.leadStartParameter?.content}`)
                                      ? (_openBlock(), _createBlock(_unref(Button), {
                                          key: 0,
                                          variant: "ghost",
                                          size: "icon",
                                          class: "h-7 w-7 group-hover:opacity-100 transition-opacity hover:bg-gray-700",
                                          onClick: ($event: any) => (copyLink(`${_unref(botLink)}${utmLink.leadStartParameter?.content}`))
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_unref(ClipboardIcon), { class: "h-3.5 w-3.5" }),
                                            _cache[14] || (_cache[14] = _createElementVNode("span", { class: "sr-only" }, "Copiar link", -1))
                                          ]),
                                          _: 2
                                        }, 1032, ["onClick"]))
                                      : _createCommentVNode("", true),
                                    (copiedLink.value === `${_unref(botLink)}${utmLink.leadStartParameter?.content}`)
                                      ? (_openBlock(), _createElementBlock("span", _hoisted_12, [
                                          _createVNode(_unref(CheckIcon))
                                        ]))
                                      : _createCommentVNode("", true)
                                  ])
                                ]),
                                _: 2
                              }, 1024),
                              _createVNode(TableCell, null, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_13, [
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      onClick: ($event: any) => (editUtmLink(utmLink))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(PencilIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"]),
                                    _createVNode(_unref(Button), {
                                      variant: "ghost",
                                      size: "icon",
                                      class: "hover:text-red-400",
                                      onClick: ($event: any) => (deleteLink(utmLink))
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_unref(TrashIcon), { class: "h-4 w-4" })
                                      ]),
                                      _: 2
                                    }, 1032, ["onClick"])
                                  ])
                                ]),
                                _: 2
                              }, 1024)
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ], 64))
                    : (_openBlock(), _createBlock(TableRowSkeleton, {
                        key: 1,
                        columns: tableHeaders.length
                      }, null, 8, ["columns"]))
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (utmLinks.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                (utmLinks.value.data.length > 0)
                  ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(utmLinks.value.data, (utmLink) => {
                      return (_openBlock(), _createBlock(MobileCard, {
                        key: utmLink.id
                      }, {
                        header: _withCtx(() => [
                          _createElementVNode("div", _hoisted_15, [
                            _createElementVNode("div", _hoisted_16, [
                              _cache[15] || (_cache[15] = _createElementVNode("span", { class: "text-[10px] uppercase font-bold text-zinc-500 tracking-wider" }, "Nome", -1)),
                              _createElementVNode("div", _hoisted_17, [
                                _createElementVNode("span", _hoisted_18, _toDisplayString(utmLink.name), 1)
                              ])
                            ])
                          ])
                        ]),
                        actions: _withCtx(() => [
                          _createElementVNode("div", _hoisted_19, [
                            _createElementVNode("div", _hoisted_20, [
                              _createElementVNode("button", {
                                onClick: ($event: any) => (editUtmLink(utmLink)),
                                class: "text-zinc-400 hover:text-white p-1"
                              }, [
                                _createVNode(_unref(PencilIcon), { class: "size-5" })
                              ], 8, _hoisted_21),
                              _createElementVNode("button", {
                                onClick: ($event: any) => (deleteLink(utmLink)),
                                class: "text-zinc-400 hover:text-red-400 p-1"
                              }, [
                                _createVNode(_unref(TrashIcon), { class: "size-5" })
                              ], 8, _hoisted_22)
                            ])
                          ])
                        ]),
                        content: _withCtx(() => [
                          _createVNode(MobileDataLabel, { label: "Campanha" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(utmLink.campaignName), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createElementVNode("div", _hoisted_23, [
                            _createVNode(MobileDataLabel, { label: "Origem" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(utmLink.source), 1)
                              ]),
                              _: 2
                            }, 1024),
                            _createVNode(MobileDataLabel, { label: "Meio" }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(utmLink.medium), 1)
                              ]),
                              _: 2
                            }, 1024)
                          ]),
                          _createVNode(MobileDataLabel, { label: "Conteúdo" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(utmLink.content), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Palavra-Chave" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(utmLink.leadStartParameter?.content), 1)
                            ]),
                            _: 2
                          }, 1024),
                          _createVNode(MobileDataLabel, { label: "Link" }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, _toDisplayString(`${_unref(botLink)}${utmLink.leadStartParameter?.content}`), 1),
                                _createElementVNode("button", {
                                  onClick: ($event: any) => (copyLink(`${_unref(botLink)}${utmLink.leadStartParameter?.content}`)),
                                  class: "rounded-lg p-1.5 text-zinc-400 transition-all hover:bg-white/10 hover:text-white"
                                }, [
                                  (copiedLink.value !== `${_unref(botLink)}${utmLink.leadStartParameter?.content}`)
                                    ? (_openBlock(), _createBlock(_unref(ClipboardIcon), {
                                        key: 0,
                                        class: "size-4 text-white"
                                      }))
                                    : (_openBlock(), _createBlock(_unref(CheckIcon), {
                                        key: 1,
                                        class: "size-4 text-green-400"
                                      }))
                                ], 8, _hoisted_26)
                              ])
                            ]),
                            _: 2
                          }, 1024)
                        ]),
                        _: 2
                      }, 1024))
                    }), 128))
                  : (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_unref(LinkIcon), { class: "size-8 mx-auto mb-3 text-zinc-700" }),
                      _cache[16] || (_cache[16] = _createTextVNode(" Nenhum link UTM encontrado "))
                    ]))
              ]))
            : _createCommentVNode("", true),
          (utmLinks.value?.pagination)
            ? (_openBlock(), _createBlock(Pagination, {
                key: 1,
                "onUpdate:page": _cache[0] || (_cache[0] = page => reloadAndGetAll({ page, perPage: perPage.value })),
                data: utmLinks.value?.pagination,
                "per-page": perPage.value,
                "onUpdate:perPage": _cache[1] || (_cache[1] = ($event: any) => ((perPage).value = $event))
              }, null, 8, ["data", "per-page"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _createVNode(DeleteConfirmationDialog, {
      open: isDeleteLinkDialogOpen.value,
      "onUpdate:open": _cache[2] || (_cache[2] = ($event: any) => ((isDeleteLinkDialogOpen).value = $event)),
      loading: isDeletingLink.value,
      onConfirm: _cache[3] || (_cache[3] = ($event: any) => {isDeletingLink.value = true; _unref(destroy)(deletingLinkId.value!).then(() => {
    _unref(toast)({
      title: 'Link UTM excluído com sucesso',
      class: 'bg-green-500 text-white',
      duration: 1500
    })
    isDeletingLink.value = false
    isDeleteLinkDialogOpen.value = false
    const index = utmLinks.value?.data.findIndex(link => link.id == deletingLinkId.value)
    if (index !== -1) utmLinks.value?.data.splice(index!, 1)
  })})
    }, null, 8, ["open", "loading"]),
    _createVNode(_unref(Dialog), {
      open: isLinkDialogOpen.value,
      "onUpdate:open": _cache[10] || (_cache[10] = ($event: any) => ((isLinkDialogOpen).value = $event)),
      onClose: closeLinkDialog
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DialogContent), { class: "sm:max-w-xl" }, {
          default: _withCtx(() => [
            _createVNode(_unref(DialogHeader), null, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogTitle), null, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(editingLinkId.value ? 'Editar link UTM' : 'Novo link UTM'), 1)
                  ]),
                  _: 1
                }),
                _createVNode(_unref(DialogDescription), null, {
                  default: _withCtx(() => _cache[18] || (_cache[18] = [
                    _createTextVNode(" Configure as informações do link UTM. ")
                  ])),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[19] || (_cache[19] = [
                    _createTextVNode("Nome"),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: utmLinkForm.value.name,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((utmLinkForm.value.name) = $event)),
                  placeholder: "Ex: Link Y"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_30, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[20] || (_cache[20] = [
                    _createTextVNode("Nome da campanha "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: utmLinkForm.value.campaignName,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((utmLinkForm.value.campaignName) = $event)),
                  placeholder: "Ex: Vendas 2024/07/10|12635162..."
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[21] || (_cache[21] = [
                    _createTextVNode("Origem "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: utmLinkForm.value.source,
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((utmLinkForm.value.source) = $event)),
                  placeholder: "Ex: FB"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_32, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[22] || (_cache[22] = [
                    _createTextVNode("Meio "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: utmLinkForm.value.medium,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((utmLinkForm.value.medium) = $event)),
                  placeholder: "Ex: ABO|1273612873681723"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_33, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[23] || (_cache[23] = [
                    _createTextVNode("Conteúdo "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: utmLinkForm.value.content,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((utmLinkForm.value.content) = $event)),
                  placeholder: "Ex: VIDEO 01|2412937293769713"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createVNode(_unref(Label), null, {
                  default: _withCtx(() => _cache[24] || (_cache[24] = [
                    _createTextVNode("Palavra-Chave "),
                    _createElementVNode("span", { class: "text-red-500" }, "*", -1)
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Input), {
                  modelValue: utmLinkForm.value.leadStartParameterContent,
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((utmLinkForm.value.leadStartParameterContent) = $event)),
                  placeholder: "Ex: Instagram_Reels"
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createVNode(_unref(DialogFooter), null, {
              default: _withCtx(() => [
                _createVNode(_unref(Button), {
                  class: "text-white",
                  variant: "ghost",
                  onClick: closeLinkDialog
                }, {
                  default: _withCtx(() => _cache[25] || (_cache[25] = [
                    _createTextVNode("Cancelar")
                  ])),
                  _: 1
                }),
                _createVNode(_unref(Button), {
                  disabled: isSaving.value || !isFormValid.value,
                  onClick: saveUtmLink
                }, {
                  default: _withCtx(() => [
                    (isSaving.value)
                      ? (_openBlock(), _createBlock(_unref(Loader2), {
                          key: 0,
                          class: "w-4 h-4 animate-spin"
                        }))
                      : _createCommentVNode("", true),
                    _createTextVNode(" " + _toDisplayString(editingLinkId.value ? 'Salvar alterações' : 'Cadastrar link'), 1)
                  ]),
                  _: 1
                }, 8, ["disabled"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["open"])
  ], 64))
}
}

})